/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
export default {
  props: {
    /**
     * Schema object
     * @type {Schema}
     */
    schema: {
      type: Object,
      required: true,
    },
  },
};
